import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { format } from "date-fns";

export const getAppointmentAvailability = async (
    clinicianId,
    month,
    serviceType,
) => {
    const res = await api.get(
        `/Patient/Clinicians/${clinicianId}/Appointments/Availability`,
        {
            params: { month, serviceType },
        },
    );

    return res.data;
};

export const useAvailableAppointments = (
    clinicianId,
    month,
    serviceType,
    isAllowed,
    loading,
) => {
    const selectedMonth = month ?? format(new Date(), "yyyyMM");

    return useQuery({
        queryKey: [
            "appointment-availability",
            clinicianId,
            selectedMonth,
            serviceType,
        ],
        queryFn: () =>
            getAppointmentAvailability(clinicianId, selectedMonth, serviceType),
        enabled:
            !!clinicianId &&
            !!month &&
            serviceType !== null &&
            !!isAllowed &&
            !loading,
        retry: 3,
        staleTime: 1000 * 60,
    });
};
